import React, { type FC } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cn } from '../../../lib';

export const SelectItem: FC<SelectPrimitive.SelectItemProps> = (props) => {
  const { className, children, ...rest } = props;

  return (
    <SelectPrimitive.Item
      className={cn(
        'focus:bg-bor-neutral-200 bg-bor-background focus-visible:bg-bor-neutral-200 relative flex w-full cursor-default items-center px-4 py-3 text-sm outline-none select-none data-disabled:pointer-events-none data-disabled:opacity-50',
        'data-[state=checked]:bg-bor-tertiary-500 data-[state=checked]:hover:bg-bor-tertiary-600 text-bor-foreground data-[state=checked]:text-bor-background',
        'border-bor-foreground/15 border-r border-l first:rounded-t-lg first:border-t last:rounded-b-lg last:border-b',
        className
      )}
      {...rest}
    >
      <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
    </SelectPrimitive.Item>
  );
};
